module.exports = __webpack_public_path__ + "static/media/dark-theme-dpf.daf4f0b3.svg";